import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class DataService {

    constructor(private readonly _http: HttpClient) {}

    // DENOMINACIONES - PAIS
    public getDenominaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    // AVISOS ETIQUETADORES
    // EXPEDICIÓN
    public getKilosExpedicionCero() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_KgExpedicionCero_Grafica', null);
    }

    public getKilosExpedicionCeroTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_KgExpedicionCero_Grid', filters);
    }

    // EXPEDICION RESPECTO DESIGNADOS
    public getKilosExpedicionRespectoDesignados(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_RelacionKgExpedicionRespectoKgDesignados_Grafica', filters);
    }

    public getKilosExpedicionRespectoDesignadosTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_RelacionKgExpedicionRespectoKgDesignados_Grid', filters);
    }

    // REETIQUETADOS
    public getKilosReetiquetados(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_RelacionKgReetiquetadosRespectoKgExpedicion_Grafica', filters);
    }

    public getKilosReetiquetadosTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_RelacionKgReetiquetadosRespectoKgExpedicion_Grid', filters);
    }

    // ETIQUETAS REIMPRESAS
    public getEtiquetasReimpresas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_CuentaEtiquetasReimpresas_Grafica', filters);
    }

    public getEtiquetasReimpresasTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_CuentaEtiquetasReimpresas_Grid', filters);
    }

    // CONFECCIONES
    public getConfecciones() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_NumConfeccionesCero_Grafica', null);
    }

    public getConfeccionesTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_NumConfeccionesCero_Grid', filters);
    }

    // DENOMINACIONES BLOQUEADAS
    public getDenominacionesBloqueadas() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_DenominacionesBloqueadas_Grafica', null);
    }

    public getDenominacionesBloqueadasTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_DenominacionesBloqueadas_Grid', filters);
    }

    // FALLOS CONEXIÓN
    public getFallosConexionServidor() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_NotificacionRetardadaConsumosEtiquetado_Grafica', null);
    }

    public getFallosConexionServidorTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/EPD_NotificacionRetardadaConsumosEtiquetado_Grid', filters);
    }

    // USUARIOS ACTIVOS WEB
    public getUsuariosActivosWeb() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/USR_UsuariosActivosWeb_Grafica', null);
    }

    public getUsuariosActivosWebTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/USR_UsuariosActivosWeb_Grid', filters);
    }

    // ETIQUETADORES IMPRIMIENDO
    public getEtiquetadoresImprimiendo() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/ETQ_EtiquetadoresImprimiendo_Grafica', null);
    }

    public getEtiquetadoresImprimiendoTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/ETQ_EtiquetadoresImprimiendo_Grid', filters);
    }

    // ALMACENES
    public getAlmacenes(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/ETQ_CuentaAlmacenes_Grafica', filters);
    }

    public getAlmacenesTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/ETQ_CuentaAlmacenes_Grid', filters);
    }

    // AVISOS DESIGNACIONES
    // EXPEDICION
    public getKilosExpedicionCeroDesignaciones() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_KgExpedicionCero_Grafica', null);
    }

    public getKilosExpedicionCeroDesignacionesTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_KgExpedicionCero_Grid', filters);
    }

    // EXPEDICION RESPECTO DESIGNADOS
    public getKilosExpedicionRespectoDesignadosDesignaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_RelacionKgExpedicionRespectoKgDesignados_Grafica', filters);
    }

    public getKilosExpedicionRespectoDesignadosDesignacionesTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_RelacionKgExpedicionRespectoKgDesignados_Grid', filters);
    }

    // DESIGNADOS RESPECTO AFORO
    public getKilosDesignadosRespectoAforoDesignaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/CUL_RelacionKgDesignadosRespectoKgAforo_Grafica', filters);
    }

    public getKilosDesignadosRespectoAforoDesignacionesTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/CUL_RelacionKgDesignadosRespectoKgAforo_Grid', filters);
    }

    // DESHABILITADAS
    public getDesignacionesDeshabilitadas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_DesignacionImpresionAutorizada_Grafica', filters);
    }

    public getDesignacionesDeshabilitadasTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_DesignacionImpresionAutorizada_Grid', filters);
    }

    // FINALIZADAS
    public getDesignacionesFinalizadas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_DesignacionFinalizada_Grafica', filters);
    }

    public getDesignacionesFinalizadasTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/DSG_DesignacionFinalizada_Grid', filters);
    }

    // AVISOS CULTIVOS
    // CULTIVOS SIN DESIGNACIONES
    public getCultivosSinDesignaciones() {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/CUL_CultivoSinDesignaciones_Grafica', null);
    }

    public getCultivosSinDesignacionesTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/CUL_CultivoSinDesignaciones_Grid', filters);
    }

    // AFORO ACTUAL RESPECTO ANTERIOR
    public getKgAforoRespectoAnterior(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/CUL_RelacionKgAforoCampanyaActualRespectoAnterior_Grafica', filters);
    }

    public getKgAforoRespectoAnteriorTabla(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralAvisos/CUL_RelacionKgAforoCampanyaActualRespectoAnterior_Grid', filters);
    }

    // CENTRAL ESTADÍSTICAS

    // ESTADÍSTICAS ETIQUETADORES
    public getEstadisticasEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstEtiquetador', filters);
    }

    // ESTADÍSTICAS DESIGNACIONES
    public getEstadisticasDesignacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstDesignacionFiltroPD', filters);
    }

    public getEstadisticasDesignacionFiltroCompleto(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstDesignacionFiltroCompleto', filters);
    }

    // ESTADÍSTICAS CULTIVOS
    public getEstadisticasCultivo(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstCultivo', filters);
    }

    // ESTADÍSTICAS ETIQUETADO
    public getEstadisticasEtiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstEtiquetadoFiltroPD', filters);
    }

    public getEstadisticasEtiquetadoFiltroCompleto(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstEtiquetadoFiltroCompleto', filters);
    }

    public getEstadisticasEtiquetadoFiltroEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstEtiquetadoFiltroEtiquetadorPD', filters);
    }

    public getEstadisticasEtiquetadoFiltroEtiquetadorCompleto(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstEtiquetadoFiltroEtiquetadorCompleto', filters);
    }

    public getRepKilosEtqCampanyasDenominacionesExcelOrCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosEtiquetadorCampanyas_Denominaciones_1', filters);
    }

    public getRepKilosEtqCampanyasDenominacionesKgExcelOrCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosEtiquetadorCampanyas_KilosDenominaciones_2', filters);
    }

    public getRepKilosCampanyasEtqExcelOrCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosCampanyasEtiquetadores_PaisDenominacion_1', filters);
    }

    public getRepKilosPaisExcelOrCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosPais_PaisKilos_AnyoTotales_2', filters);
    }

    public getRepKilosPaisDenoExcelOrCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosPais_PaisKilos_AnyoDenominacion_3', filters);
    }

    public getRepKilosDenoExcelOrCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosDenominacion_DenominacionKilos_AnyoTotales_2', filters);
    }

    public getRepKilosDenoPaisExcelOrCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosDenominacion_DenominacionKilos_AnyoPais_3', filters);
    }

    public getRepKilosEtqExcelOrCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosEtiquetadores_AnyoPaisDenominacion_1', filters);
    }

    public getEstGridKilosPais(filters){
      return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosPais_PaisKilos_AnyoTotales_2', filters);
    }

    public getEstGridKilosPaisDeno(filters){
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosPais_PaisKilos_AnyoDenominacion_3', filters);
    }

    public getEstGridKilosDeno(filters){
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosDenominacion_DenominacionKilos_AnyoTotales_2', filters);
    }

    public getEstGridKilosDenoPais(filters){
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosDenominacion_DenominacionKilos_AnyoPais_3', filters);
    }

    public getEstGridKilosCampanyasEtq(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosCampanyasEtiquetadores_PaisDenominacion_1', filters);
    }

    public getEstGridKilosEtq(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosEtiquetadores_AnyoPaisDenominacion_1', filters);
    }

    public getRepKilosCampanyasPaisesExcelOrCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosCampanyas_Paises_1', filters);
    }

    public getRepKilosCampanyasDenominacionesExcelOrCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosCampanyas_Denominaciones_2', filters);
    }

    public getRepKilosCampanyasKilosPaisDenominacionesExcelOrCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEstGrid_Etiquetado_KilosCampanyas_KilosPaisDenominaciones_3', filters);
    }

    public getEstGridKilosCampanyasPaises(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosCampanyas_Paises_1', filters);
    }

    public getEstGridKilosCampanyasDenominaciones(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosCampanyas_Denominaciones_2', filters);
    }

    public getEstGridKilosCampanyasKilosPaisDenominaciones(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosCampanyas_Denominaciones_2', filters);
    }

    public getEstGridKilosEtqCampanyasDenominacionesKg(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosEtiquetadorCampanyas_KilosDenominaciones_2', filters);
    }

    public getEstGridKilosEtqCampanyasDenominaciones(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/CentralEstadisticas/GetEstGrid_Etiquetado_KilosEtiquetadorCampanyas_Denominaciones_1', filters);
    }

    // AYUDA
    public getDocHelp(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }

}
